import { render, staticRenderFns } from "./PackageGuidlineModal.vue?vue&type=template&id=60d4c71e&scoped=true"
import script from "./PackageGuidlineModal.vue?vue&type=script&lang=js"
export * from "./PackageGuidlineModal.vue?vue&type=script&lang=js"
import style0 from "./PackageGuidlineModal.vue?vue&type=style&index=0&id=60d4c71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4c71e",
  null
  
)

export default component.exports